import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "text-h6" }
const _hoisted_2 = { class: "header-form" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, "Seleccionar Campos a Exportar", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_table_component = _resolveComponent("table-component")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    modelValue: _ctx.toggleExportFieldModal,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.toggleExportFieldModal) = $event)),
    persistent: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, { class: "export-field-component" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _hoisted_3,
                  _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                    color: "negative",
                    icon: "close"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_tooltip, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Cerrar ventana")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })), [
                    [_directive_close_popup]
                  ])
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, null, {
            default: _withCtx(() => [
              _createVNode(_component_table_component, {
                loading: _ctx.loading,
                enablePagination: false,
                enableMultipleSelection: true,
                selectedItems: _ctx.selectedItems,
                onSelectedItems: _ctx.updateSelectedItems,
                tableStyle: _ctx.TableStyle.SUBSERVICE
              }, null, 8, ["loading", "selectedItems", "onSelectedItems", "tableStyle"])
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_actions, { align: "center" }, {
            default: _withCtx(() => [
              _createVNode(_component_q_btn, {
                color: "primary",
                label: "Aceptar",
                onClick: _ctx.onAccept
              }, null, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}